import styled, { css } from 'styled-components';

type Props = {
    $disabled: boolean;
}

export const ButtonBox = styled.button<Props>`
    color: white;
    font-size: 16px;
    background-color: rgb(218, 57, 43);
    border-radius: 8px;
    border: 1px solid rgb(218, 57, 43);
    text-decoration: none;
    cursor: pointer;
    -webkit-transition: all;
    -o-transition: all;
    transition: all;
    -webkit-transition-duration: 300ms;
    -o-transition-duration: 300ms;
    transition-duration: 300ms;
    display: inline-block;
    padding: 8px 12px;

    ${({ $disabled }) => $disabled && css`
        color: inherit;
        background-color: white;
        border-color: rgb(39, 36, 67);
    `}

    &:hover {
        color: inherit;
        background-color: white;
        border-color: rgb(39, 36, 67);
    }
`;

// .button .icon {
//     margin-right: 6px;
// }